import {
  FormControl,
  Select,
  MenuItem,
  RadioGroup,
  FormControlLabel,
  Radio,
  Checkbox,
  TextField,
} from '@mui/material'
import { Survey } from 'interface'

export default function RenderSurvey({ survey }: { survey: Survey }) {
  let ex: JSX.Element = <></>
  switch (survey.type) {
    case 'select':
      ex = (
        <FormControl size="small" sx={{ width: 200 }}>
          <Select defaultValue={0}>
            {survey.surveySelects?.map((s, i) => {
              return (
                <MenuItem value={i} key={s.id}>
                  {s.text}
                </MenuItem>
              )
            })}
          </Select>
        </FormControl>
      )
      break
    case 'radio':
      ex = (
        <FormControl size="small">
          <RadioGroup
            sx={{
              display: 'flex',
              flexDirection: {
                sm: 'column',
                md: 'row',
              },
            }}
            defaultValue={0}
          >
            {survey.surveySelects?.map((s, i) => {
              return (
                <FormControlLabel
                  key={s.id}
                  value={i}
                  control={<Radio />}
                  label={s.text}
                />
              )
            })}
          </RadioGroup>
        </FormControl>
      )
      break
    case 'checkbox':
      ex = (
        <FormControl size="small">
          <RadioGroup
            sx={{
              display: 'flex',
              flexDirection: {
                sm: 'column',
                md: 'row',
              },
            }}
            defaultValue={0}
          >
            {survey.surveySelects?.map((s, i) => {
              return (
                <FormControlLabel
                  key={s.id}
                  value={i}
                  control={<Checkbox />}
                  label={s.text}
                />
              )
            })}
          </RadioGroup>
        </FormControl>
      )
      break

    case 'free':
      ex = (
        <TextField
          label={survey.text}
          multiline
          rows={3}
          margin="dense"
          fullWidth
          variant="outlined"
          placeholder={'自由入力'}
          focused
        />
      )
      break
    default:
      break
  }
  return ex
}
